import { axiosInstance } from "../../../utils/axios_config"

export default function IntegrationProofService() {

    this.getProof = async deliveryKey => {
        return axiosInstance.get(`Proof/${deliveryKey}`);
    }
}